module.exports = __webpack_public_path__ + "static/media/Leash_Blue_01.8b0f4435.png";